import React from "react";
import GovernanceLinkNav from "../components/GovernanceLinkNav";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import PdfPointer from "../components/PdfPointer";
import Footer from "../components/Footer";

import LinedLinks from "../components/Navigation/LinedLinks";

const AssociationRegulationAndPolicies = () => {
  const pdfs = [
    {
      label: `لائحة وآلية التحقق من وصول التبرع من المتبرع إلى المستفيد النهائي`,
      url: "pdfs/association_regulation_and_policies/all_imams_ruqyah_al_hal_from_the_messenger_of_ai_bar_from_the_donor_to_the_beneficiary_north.pdf",
      size: '260 KB'
    },
    {
      label: `لائحة صرف المساعدات`,
      url: "pdfs/association_regulation_and_policies/gods_aid_disbursement_list.pdf",
      size: '768 KB'
    },
    {
      label: `لائحة شراء الأصول`,
      url: "pdfs/association_regulation_and_policies/gods_asset_purchase_list.pdf",
      size: '217 KB'
    },
    {
      label: `لائحة توضيح أدوار مجلس الإدارة وبرامجه لمكافحة غسيل الأموال وتمويل الإرهاب`,
      url: "pdfs/association_regulation_and_policies/to_the_back_of the roles_of_the_board_of_directors_and_its_programs_the_call_on_money_and_terrorist_financing.png",
      size: '204 KB'
    },
    {
      label: `لائحة تعيين المدير التنفيذي`,
      url: "pdfs/association_regulation_and_policies/gods_executive_director_appointment_list.pdf",
      size: '1,207 KB'
    },
    {
      label: `لائحة الموارد البشرية`,
      url: "pdfs/association_regulation_and_policies/human_resource_list.pdf",
      size: '1,353 KB'
    },
    {
      label: `لائحة المشتريات`,
      url: "pdfs/association_regulation_and_policies/gods_list_of_investigations.pdf",
      size: '434 KB'
    },
    {
      label: `لائحة المشتريات والتعاقدات`,
      url: "pdfs/association_regulation_and_policies/allah_list_of_purchases_and_supplies.pdf",
      size: '377 KB'
    },
    {
      label: `سياسة مصفوفة الصلاحيات بين مجلس الإدارة والإدارة التنفيذية`,
      url:"pdfs/association_regulation_and_policies/peace_matrix_policy_between_the_board_of_directors_and_the_cooperative_management.pdf",
      size: '359 KB'
    },
    {
      label: `سياسة قواعد السلوك`,
      url:"pdfs/association_regulation_and_policies/code_of_conduct_policy.pdf",
      size: '383 KB'
    },
    {
      label: `سياسة خصوصية البيانات`,
      url:"pdfs/association_regulation_and_policies/god_vicat_privacy_policy.pdf",
      size: '471 KB'
    },
    {
      label: `سياسة جمع التبرعات`,
      url:"pdfs/association_regulation_and_policies/for_donation_collection_policy.pdf",
      size: '293 KB'
    },
    {
      label: `سياسة توجيه مبلغ التبرع إلى مشروع آخ`,
      url:"pdfs/association_regulation_and_policies/to_the_policy_of_directing_the_donation_amout_to_another_project.pdf",
      size: '196 KB'
    },
    {
      label: `سياسة تنظيم العلاقة مع المستفيدين`,
      url:"pdfs/association_regulation_and_policies/gods_education_policy_angels_with_beneficiaries.pdf",
      size: '368 KB'
    },
    {
      label: `سياسة تعارض المصالح لجمعية التنمية الأهلية`,
      url:"pdfs/association_regulation_and_policies/for_the_policy_of_practicing_the_interests_of_the_civil_development.pdf",
      size: '837 KB'
    },
    {
      label: `سياسة التعامل مع الشركاء المنفذين والأطراف الثلاثة`,
      url:"pdfs/association_regulation_and_policies/allah_policy_on_dealing_with_implementing_partners_and_third_parties.pdf",
      size: '428 KB'
    },
    {
      label: `سياسة الاستبدال والإرجاع الخاصة بالتبرعات`,
      url:"pdfs/association_regulation_and_policies/allahs_donation_return_and_exchange_policy.pdf",
      size: '160 KB'
    },
    {
      label: `سياسة الاحتفاظ بالوثائق وإتلافها`,
      url:"pdfs/association_regulation_and_policies/allahs_policy_of_keeping_chips_and_their_words.pdf",
      size: '327 KB'
    },
    {
      label: `سياسة الإبلاغ عن المخالفات وحماية مقدمي البلاغات`,
      url:"pdfs/association_regulation_and_policies/analyze_the_whistleblowing_policy_and_protect_sewer_providers.pdf",
      size: '499 KB'
    },
    {
      label: `سياسة إدارة المخاطر`,
      url:"pdfs/association_regulation_and_policies/god_risk_management_policy.pdf",
      size: '458 KB'
    },
    {
      label: `سياسة إدارة المتطوعين`,
      url:"pdfs/association_regulation_and_policies/god_politics_management_wrestlers.pdf",
      size: '285 KB'
    },
    {
      label: `سياسة آليات الرقابة والإشراف على الجمعية`,
      url:"pdfs/association_regulation_and_policies/the_limit_of_the_consolation_of_the_colleges_of_control_and_supervision_of_the_association.pdf",
      size: '334 KB'
    },
    {
      label: `سياسات الصرف للبرامج والأنشطة والمصروفات الإدارية والعمومية`,
      url:"pdfs/association_regulation_and_policies/allahs_spending_policies_programs_acitivities_administrative_and_general_expenses.pdf",
      size: '617 KB'
    },
    {
      label: `دليل السياسات والإجراءات المالية والمحاسبية`,
      url:"pdfs/association_regulation_and_policies/allah_is_sick_of_financial_and_accounting_policies_and_procedures.pdf",
      size: '2,588 KB'
    },
    {
      label: `اللائحة المالية لجمعية التنمية الأهلية بجزيرة دارين`,
      url:"pdfs/association_regulation_and_policies/allah_financial_list_of_the_civil_development_association_of_darain_island.pdf",
      size: '1,591 KB'
    },
    {
      label: `اللائحة الأساسية جمعية التنمية`,
      url:"pdfs/association_regulation_and_policies/god_basic_residence_association.pdf",
      size: '570 KB'
    },
    {
      label: `اجراءات حظر إبلاغ أو تنبيه العميل أو أي شخص ذو علاقة بشبهة غسيل الأموال وتمويل الإرهاب`,
      url:"pdfs/association_regulation_and_policies/god_procedures_report_or_alert_the_flood_or_any_person_in_a_relationship_with_the_prophet_about_money_and_financing_terrorrism.pdf",
      size: '200 KB'
    },
    {
      label: `إجراءات الفحص المتبعة بالجمعية لضمان معايير عالية عند التوظيف`,
      url:"pdfs/association_regulation_and_policies/allah_resident_examination_procedures_society_guarantee_high_standards_when_hiring.pdf",
      size: '432 KB'
    },
    {
      label: `إجراءات التعامل مع المقبوضات في الجمعية`,
      url:"pdfs/association_regulation_and_policies/procedures_for_dealing_with_receipts_in_the_body.pdf",
      size: '181 KB'
    },
    {
      label: `آلية قبول أعضاء الجمعية العمومية`,
      url:"pdfs/association_regulation_and_policies/all_somatic_organ_acceptance_mechanism.pdf",
      size: '560 KB'
    },
    {
      label: `آلية التحقق لاختبار فاعلية كفاية السياسات والإجراءات والضوابط لمكافحة تمويل الإرهاب`,
      url:"pdfs/association_regulation_and_policies/all_reporting_mechanism_in_case_of_suspicion_of_a_money_laundering_and_terrorist_financing_agent.pdf",
      size: '297 KB'
    },
    {
      label: `آلية التأكد من استحقاق المستفيد للخدمة`,
      url:"pdfs/association_regulation_and_policies/to_verify_the_saudi_citizenship_mechanism.pdf",
      size: '269 KB'
    },
    {
      label: `آلية الإبلاغ في حال وجود شبهة غسيل أموال وتمويل الإرهاب`,
      url:"pdfs/association_regulation_and_policies/all_reporting_mechanism_in_case_of_suspicion_of_a_money_laundering_and_terrorist_financing_agent_2.pdf",
      size: '219 KB'
    },
    {
      label: `آلية استرداد التبرع للمتبرع`,
      url:"pdfs/association_regulation_and_policies/donation_refund_mechanism_for_the_donor.pdf",
      size: '185 KB'
    },
  ];

  return (
    <>
      <HeaderOriginal />
      <StickyNavBar />
      <section className="pb-4 md:pb-10 pt-4 md:pt-10">
        <div className="max-w-screen-xl mx-auto px-3">
          <h1 className="text-primary font-bold text-center mt-4">
            لائحة وسياسات الجمعية
          </h1>
          <LinedLinks link={'/association_regulation_and_policies'} label={'لائحة وسياسات الجمعية'}/>
          <div className="mt-8">
            {pdfs.map((pdf, index) => (
              <PdfPointer key={index}
                data={pdf}
              />
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AssociationRegulationAndPolicies;
